import React from 'react';
import Section from '../ui/Section';

const Team = () => {
  const team = [
    {
      name: "Ronny Müller",
      role: "Co-Founder & Managing Partner",
      desc: "Seit 1997 im Bauwesen verankert. Stieg in das Familienunternehmen seines Vaters ein und übernahm ab 2002 die operative Führung. Er baute den klassischen Massivbaubetrieb erfolgreich auf circa 95 Beschäftigte aus. Unter seiner Leitung wurden jährlich über 100 Ein-, Doppel- und Reihenhäuser sowie mehrere Mehrfamilienhäuser im Raum Potsdam, Berlin, Hamburg und Leipzig massiv errichtet. Bei 51north verantwortet er die operative Umsetzung, das Partnermanagement sowie die Integration realer Baupraxis in die modulare Serienfertigung.",
      image: "/images/team-ronny-mueller.webp"
    },
    {
      name: "Sebastian Janus",
      role: "Co-Founder",
      desc: "Verantwortet die strategische Ausrichtung, das kaufmännische Controlling sowie die kundenorientierte Strukturierung von Projekt- und Baufinanzierungen. Er sorgt dafür, dass die modularen Gebäudesysteme von 51north wirtschaftlich perfekt durchdacht sind und maximale Sicherheit für Ihr Immobilien-Investment bieten.",
      image: "/images/team-sebastian-janus.webp"
    },
    {
      name: "Sebastian Heidrich",
      role: "Co-Founder",
      desc: "Verantwortlich für Produktentwicklung und das technologische Schnittstellenmanagement. Er steuert die Produktion der standardisierten Industriebauteile und treibt die kontinuierliche Qualitätssicherung und Weiterentwicklung unserer Raummodule voran, damit Ihr neues Zuhause optisch und funktionell begeistert.",
      image: "/images/team-sebastian-heidrich.webp"
    }
  ];

  return (
    <Section id="team">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 lg:sticky lg:top-32 h-fit">
          <h2 className="text-4xl md:text-5xl mb-6">KÖPFE HINTER DER EFFIZIENZ</h2>
          <p className="font-inter text-brand-text/70 text-lg">
            Gemeinsam machen wir serielles Bauen planungssicher, wertbeständig und absolut stressfrei für Sie.
          </p>
        </div>
        
        <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16">
          {team.map((member, idx) => (
            <div key={idx} className="border-t border-brand-text/20 pt-6 group">
              {/* Фотографии уменьшены до w-[65%] (было 85%) для более элегантного журнального стиля */}
              <div className="mb-6 aspect-[4/5] w-[65%] overflow-hidden bg-brand-text/5 relative flex items-center justify-center border border-brand-text/10">
                {member.image ? (
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="w-full h-full object-cover grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 ease-out"
                  />
                ) : (
                  <div className="text-brand-text/20 flex flex-col items-center gap-4 group-hover:text-brand-text/40 transition-colors duration-500">
                    <div className="font-mono text-5xl tracking-tighter">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div className="font-mono text-[10px] uppercase tracking-widest border border-current px-3 py-1">
                      Bild folgt
                    </div>
                  </div>
                )}
              </div>
              
              <h4 className="text-2xl mb-2">{member.name}</h4>
              <p className="font-mono text-xs text-brand-text/50 uppercase tracking-widest mb-6">{member.role}</p>
              <p className="font-inter text-brand-text/80 leading-relaxed text-sm">
                {member.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Team;